import Orders from '@/services/orders'
import * as types from './mutation-types'
import store from '../..'
import PublicTracking from '@/services/publicTracking'

export const loadOrders = async ({ commit, state }, filters = null) => {        
  commit(types.RESET_ORDERS)

  if (filters) {
    commit(types.SET_FILTER_DATE, { params: filters })
  }

  const response = await Orders.loadOrders({
    ...filters,
    limit: state.pagination.limit,
    offset: 0
  })
  
  let orders = response.productBalance || []  
  const totalReceived = orders.length
  
  orders = orders.map((order) => {
    const uniqueKey = [
      order.FAT_SEQUENCIA,
      order.ITE_SEQUENCIA,
      order.PRO_CODIGO,
      order.GRA_TAMANHO,
      order.NUMERONF,
      order.COR_NOME,
    ].filter(Boolean).join('_')
  
    return { ...order, UNIQUE_KEY: uniqueKey }
  })  
  
  commit(types.FILL_ORDERS, { orders })

  const hasMore = totalReceived === state.pagination.limit
  commit(types.SET_PAGINATION, {
    pagination: {
      offset: orders.length,
      hasMore
    }
  })  
    
  commit(types.SET_CACHE_LOADED, { loaded: true })

  return orders
}

export const loadMoreOrders = async ({ commit, state }) => {   
  if (state.pagination.isLoadingMore || !state.pagination.hasMore) {
    return []
  }
  
  commit(types.SET_PAGINATION, {
    pagination: { isLoadingMore: true }
  })

  try {
    const response = await Orders.loadOrders({
      ...state.activeFilterDate.params,
      limit: state.pagination.limit,
      offset: state.pagination.offset
    })
    
    let orders = response.productBalance || []
    const totalReceived = orders.length    
    orders = orders.map((order) => {
      const uniqueKey = [
        order.FAT_SEQUENCIA,
        order.ITE_SEQUENCIA,
        order.PRO_CODIGO,
        order.GRA_TAMANHO,
        order.NUMERONF,
        order.COR_NOME,
      ].filter(Boolean).join('_')
    
      return { ...order, UNIQUE_KEY: uniqueKey }
    })

    
    commit(types.APPEND_ORDERS, { orders })    
    
    const hasMore = totalReceived === state.pagination.limit
    
    commit(types.SET_PAGINATION, {
      pagination: {
        offset: state.pagination.offset + orders.length,
        hasMore,
        isLoadingMore: false
      }
    })   
    return orders
  } catch (error) {
    commit(types.SET_PAGINATION, {
      pagination: { isLoadingMore: false }
    })
    throw error
  }
}
export const setFilterDate = async ({ commit }, filterDate) => {
  commit(types.SET_FILTER_DATE, filterDate)
}

export const loadPublicTrackingOrder = async ({ commit }, { ped_codigo, cpf, recaptchaToken }) => {  
  commit(types.RESET_ORDERS)
  commit(types.FILL_OCCURRENCES, { occurrences: [] })  
  const response = await PublicTracking.loadPublicTrackingOrder(ped_codigo, cpf, recaptchaToken)  
  const {order, occurrences} = response
  

  commit(types.FILL_ORDERS, { orders: [order] })  
  commit(types.FILL_OCCURRENCES, { occurrences })
  return { order, occurrences }
}

export const toggleSidebar = async ({ commit }, opened) => {
  const opened_store = store.getters['orders/getSidebarOpened'] || false

  if (typeof opened == 'undefined') opened = !opened_store
  commit(types.TOGGLE_SIDEBAR, { sidebar_opened: opened })
}

const generateUID = function () {
  let rnd = Math.random() * (10000 - 1) + 1
  rnd = rnd + ''
  rnd = rnd.replace('.', '')
  let uid = `${rnd}`
  return uid
}

export const loadBonus = async ({ commit }, filters) => {   
  let response = await Orders.getBonus(filters)  
  const bonus = response.bonus || []
  
  return bonus
}

export const loadOccurrences = async ({ commit, state }, filters) => {  
  if(state.cache.occurrencesLoaded && state.occurrences.some(occ => occ.FAT_SEQUENCIA == filters.fat_sequencia)) {
    return state.occurrences
  }
  let response = await Orders.getOccurrences(filters)  
  let occurrences = response.occurrences || []
  occurrences = occurrences.length > 0  && !state.occurrences.some(state => state.FAT_SEQUENCIA == occurrences[0].FAT_SEQUENCIA) ? [...occurrences, ...state.occurrences] : occurrences
  commit(types.FILL_OCCURRENCES, { occurrences })
  return occurrences
}

export const resetOccurrences = async ({ commit }) => {
  commit(types.FILL_OCCURRENCES, { occurrences: [] })
}

export const getPhotographCollection = async ({ commit }, filters) => {   
  let response = await Orders.getPhotographCollection(filters)  
  const photographCollection = response.photographCollection || []
  
  return photographCollection
}